import React from 'react';
import { FadeIn, Section } from './ui';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'El Blindaje MAI/PPI',
    desc: 'Plantillas legales listas para adaptar tus evaluaciones a alumnos con TEA, TDAH o discalculia en 5 minutos. Con respaldo legal argentino. El documento que te protege ante directivos, padres e inspectores.',
    value: '$8.990'
  }, {
    title: 'ChatGPT para Profes de Matemática',
    desc: '25 prompts listos para copiar y pegar que generan ejercicios, guías, rúbricas y explicaciones en menos de 60 segundos. Nunca más perdás horas buscando materiales en internet.',
    value: '$7.990'
  }, {
    title: 'La Planilla Maestra de Notas',
    desc: 'Sistema en Google Sheets con fórmulas automáticas que calcula promedios, detecta alumnos en riesgo y te avisa antes de que sea tarde. Gestión de 200 alumnos en 15 minutos semanales.',
    value: '$6.990'
  }];
  return <Section variant="dark" data-id="element-37">
      <FadeIn data-id="element-38">
        <h2 className="text-[28px] md:text-4xl font-black text-brand-orange mb-2 text-center" data-id="element-39">
          Y eso no es todo. También recibís estos 3 Bonus:
        </h2>
        <p className="text-gray-400 text-center mb-12 text-lg" data-id="element-40">
          Incluidos sin costo adicional en tu compra
        </p>
      </FadeIn>

      <div className="space-y-6" data-id="element-41">
        {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.15} data-id="element-42">
            <div className="bg-dark-light border border-brand-gold/40 p-6 md:p-8 rounded-2xl relative hover:border-brand-gold transition-colors duration-300" data-id="element-43">
              <div className="inline-flex items-center gap-2 bg-brand-gold/10 text-brand-gold text-xs font-bold px-3 py-1.5 rounded-full mb-4 border border-brand-gold/20" data-id="element-44">
                <Gift size={14} data-id="element-45" />
                <span data-id="element-46">BONUS {i + 1} — GRATIS</span>
              </div>

              <h3 className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-47">
                {bonus.title}
              </h3>

              <p className="text-gray-300 text-base leading-relaxed mb-4" data-id="element-48">
                {bonus.desc}
              </p>

              <div className="text-sm text-gray-500 font-medium" data-id="element-49">
                Valor: <span className="line-through" data-id="element-50">{bonus.value}</span>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}